module.exports = __webpack_public_path__ + "img/kjzy.99d57fd6.png";